import {
  CALENDAR_ACCOUNT_MANAGERS_URL,
  CALENDAR_BOOKED_TASKS_URL,
  CALENDAR_CLIENT_SEARCH_URL,
  CALENDAR_JOBS_URL,
  CALENDAR_SITE_SEARCH_URL,
  CALENDAR_UNBOOKED_TASKS_URL,
  SET_CALENDAR_ACCOUNT_MANAGERS,
  CALENDAR_FREQUENCY_COUNT_URL,
  CALENDAR_TASK_FREQUENCIES_URL,
  CALENDAR_JOB_TASKS_URL,
  CALENDAR_FREQUENCIES_REMINDER_URL,
  CALENDAR_JOB_TASK_FREQUENCIES_URL,
  CALENDAR_JOB_ADMIN_URL,
  CALENDAR_TASK_RESOURCE_URL,
  CALENDAR_SEARCH_CONTRACTORS_URL,
  CALENDAR_ALLOCATE_JOB_MANAGER_URL,
  CALENDAR_CREATE_UPDATE_JOB_URL,
  CALENDAR_JOB_RESOURCING_URL,
  CALENDAR_CREATE_AD_HOC_JOB_URL,
  CALENDAR_SHIFT_RESOURCING_URL,
  CALENDAR_EXTEND_JOB_URL,
  JOB_PARENT_TASKS_URL,
  TASK_ASSIGNEE_URL,
  CALENDAR_ALLOCATE_ACC_MANAGER_URL,
  UPDATE_JOB_SHIFT_PLAN_URL,
  ADD_JOB_SHIFT_PLAN_URL,
  GET_JOB_SHIFT_PLANNS_URL,
  DELETE_JOB_SHIFT_PLAN_URL,
  GET_ALL_SUPERVISORS_URL,
  GET_SCOPE_STATES_URL
} from "../../dataProvider/constant";

import { baseApiInstance, scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";
import moment from "moment";
import { serializeJobs, serializeResourcingTasks } from "../../components/v2/Calendar/JobResourcing/serializer";

export const getTaskStatusByStateId = {
  0: "Not Approved", //Not Approved
  1: "Booked", //Booked
  2: "unknown", //unknown
  3: "Allocated", //Allocated
  4: "unknown", //unknown
  5: "Outsourced", //Outsourced
  6: null,
  7: "Started", //Started
  8: "Paused", //Paused
  9: "Completed", //Completed
  10: "Signed Off", //Signed Off
  12: "Cancelled" //Cancelled
};

const serializeFilters = (filters) => {
  return "";
}

export const getDurationFromCount = (dayCount) => {
  if (!dayCount || isNaN(dayCount)) {
    return "-"
  } else {
    let months = dayCount / 31;
    if (months < 1) {
      return `${dayCount} Day${dayCount > 1 ? "s" : ""}`
    } else if (months === 1) {
      return "1 Month";
    } else {
      let remainingCount = dayCount % 31;
      if (months < 2) {
        return `1+ Month`
      } else {
        return `${months.toFixed(0)}${remainingCount !== 0 ? "+" : ""} Months`
      }
    }
  }
}

export const getClientsBySearch = () => dispatch => {
  let url = CALENDAR_CLIENT_SEARCH_URL;

  return scopeApiInstance.get(url).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getSitesBySearch = (params = {}) => dispatch => {
  let url = CALENDAR_SITE_SEARCH_URL;
  return scopeApiInstance.get(url, { params: params }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}


export const getAccountManagers = (organisationId) => dispatch => {
  let url = `${CALENDAR_ACCOUNT_MANAGERS_URL}?organisation_id=${organisationId}`;
  return baseApiInstance.get(url).then((res) => {
    if (res && res.data && res.data.data && res.data.data.account_managers) {
      dispatch({
        type: SET_CALENDAR_ACCOUNT_MANAGERS,
        payload: res.data.data.account_managers
      })
      return Promise.resolve(res.data.data.account_managers);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getDurationInDays = (dayCount) => {
  if (!dayCount || isNaN(dayCount)) {
    return "-"
  }
  else {
    if (dayCount === 1) {
      return `${dayCount} day`
    } else {
      return `${dayCount} days`
    }
  }

}

export const getJobs = (startDate, endDate, filters = {}, canSeeValues = false) => dispatch => {
  let url = CALENDAR_JOBS_URL
  return scopeApiInstance.get(url, {
    params: {
      start_date: moment(startDate).format("YYYY-MM-DD 00:00:00"),
      end_date: moment(endDate).format("YYYY-MM-DD 00:00:00"),
      page: 1,
      limit: 10000,
      ...(filters.site_id ? { site_id: filters.site_id } : {}),
      ...(filters.client_id ? { client_id: filters.client_id } : {}),
      ...(filters.job_state ? { job_state: JSON.stringify(filters.job_state) } : {}),
      ...(filters.job_allocated_to ? { job_allocated_to: filters.job_allocated_to } : {}),
      ...(filters.start_date ? { start_date: filters.start_date } : {}),
      ...(filters.end_date ? { end_date: filters.end_date } : {}),
      ...(filters.job_id ? { job_id: filters.job_id } : {}),
      ...(filters.contract_id ? { contract_id: filters.contract_id } : {}),
      ...(filters.state_id ? { state_id: filters.state_id} : {})
    }
  }).then(res => {
    if (res && res.data && res.data.data) {
      let newTasks = res.data.data.jobs.jobs_list;
      let formattedTasks = newTasks.map(x => {
        let start = moment.utc(x.job_start_date);
        let end = moment.utc(x.job_end_date);
        let dayCount = moment(end).diff(start, "days") + 1;
        // let duration = getDurationFromCount(dayCount, start.month());
        let duration = getDurationInDays(dayCount);
        const jobName = canSeeValues ? x.job_title : `${x.job_number}/${x.site_name}`;
        return {
          ...x,
          job_title: jobName,
          start: moment(start).format("DD/MM/YYYY"),
          end: moment(end).format("DD/MM/YYYY"),
          dayDuration: dayCount,
          name: jobName,
          id: "job_" + x.job_id,
          job_id: x.job_id,
          isJob: true,
          task_category: x.task_category,
          duration: duration,
          children: [],
          isChild: false,
          selectable: true,
          dayStamp: moment(start).unix()
        }
      });
      return Promise.resolve(formattedTasks);
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

const getFormattedBookedTasks = (res) => {
  let allTasks = [];

  res.booked_jobs.forEach(({ task_frequencies, ...job }) => {
    let jobDetails = {
      ...job,
      isJob: true,
      task_category: job.task_category,
      isChild: false,
      selectable: true,
      id: `job_${job.job_id}`,
      name: job.job_number
    };
    let jobTasks = [];
    task_frequencies.forEach(freq => {
      let start = moment.utc(freq.start_date);
      let end = moment.utc(freq.end_date);
      let dayCount = moment(end).diff(start, "days") + 1;
      let duration = getDurationFromCount(dayCount, start.month());
      jobTasks.push({
        start: moment(start).format("DD/MM/YYYY"),
        end: moment(end).format("DD/MM/YYYY"),
        start_date: freq.start_date,
        end_date: freq.end_date,
        dayDuration: dayCount,
        duration: duration,
        id: freq.quote_task_id,
        task_id: freq.task_id,
        quote_task_id: freq.quote_task_id,
        job_id: job.job_id,
        name: freq.quote_task_label,
        quote_type: job.quote_type ? job.quote_type : "QUOTE",
        selectable: true,
        isChild: true,
        isJob: false,
        job_state: "Booked",
        dayStamp: moment(start).unix()
      })
      if (!jobDetails.start_date || (jobDetails.start_date && moment(jobDetails.start_date).isAfter(start))) {
        jobDetails.start_date = freq.start_date
      }
      if (!jobDetails.end_date || (jobDetails.end_date && moment(jobDetails.end_date).isBefore(end))) {
        jobDetails.end_date = freq.end_date
      }
    })
    jobDetails.start = moment(jobDetails.start_date).format("DD/MM/YYYY");
    jobDetails.end = moment(jobDetails.end_date).format("DD/MM/YYYY");
    let dayCount = moment(jobDetails.end_date).diff(moment(jobDetails.start_date), "days") + 1;
    let duration = getDurationFromCount(dayCount, moment(jobDetails.start_date).month());
    jobDetails.dayDuration = dayCount;
    jobDetails.duration = duration;
    jobDetails.taskIds = jobTasks.map(x => x.quote_task_id);
    allTasks.push(jobDetails)
    allTasks.push(...jobTasks);
  })

  res.booked_tasks.forEach(({ task_frequencies, ...task }) => {
    let taskFreqs = [];
    let taskDetails = {
      ...task,
      isJob: false,
      isChild: false,
      selectable: false,
      id: `booked_${task.task_id}`,
      name: task.task_name,
    };
    task_frequencies.forEach(freq => {
      let start = moment.utc(freq.start_date);
      let end = moment.utc(freq.end_date);
      let dayCount = moment(end).diff(start, "days") + 1;
      let duration = getDurationFromCount(dayCount, start.month());
      taskFreqs.push({
        start: moment(start).format("DD/MM/YYYY"),
        end: moment(end).format("DD/MM/YYYY"),
        start_date: freq.start_date,
        end_date: freq.end_date,
        dayDuration: dayCount,
        duration: duration,
        task_id: task.task_id,
        id: freq.quote_task_id,
        quote_task_id: freq.quote_task_id,
        job_id: null,
        client_id: task.client_id,
        client_contact_person_id: task.client_contact_person_id,
        site_id: task.site_id,
        name: freq.quote_task_label,
        selectable: true,
        isChild: true,
        main_task_label: task.task_name,
        quote_type: task.quote_type ? task.quote_type : "QUOTE",
        isJob: false,
        job_state: "Not Approved",
        dayStamp: moment(start).unix()
      })
      if (!taskDetails.start_date || (taskDetails.start_date && moment(taskDetails.start_date).isAfter(start))) {
        taskDetails.start_date = freq.start_date
      }
      if (!taskDetails.end_date || (taskDetails.end_date && moment(taskDetails.end_date).isBefore(end))) {
        taskDetails.end_date = freq.end_date
      }
    })

    taskDetails.start = moment(taskDetails.start_date).format("DD/MM/YYYY");
    taskDetails.end = moment(taskDetails.end_date).format("DD/MM/YYYY");
    let dayCount = moment(taskDetails.end_date).diff(taskDetails.start_date, "days") + 1;
    let duration = getDurationFromCount(dayCount, moment(taskDetails.start_date).month());
    taskDetails.dayDuration = dayCount;
    taskDetails.duration = duration;
    taskDetails.taskIds = taskFreqs.map(x => x.quote_task_id);
    allTasks.push(taskDetails)
    allTasks.push(...taskFreqs);
  })
  return allTasks;
}

const markTasks = (res) => {
  let allTasks = [];
  allTasks.push(...res.booked_jobs.map(job => {
    let allFreqs = job.task_frequencies.map(freq => {
      let start = moment.utc(freq.start_date);
      let end = moment.utc(freq.end_date);
      let dayCount = moment(end).diff(start, "days") + 1;
      // let duration = getDurationFromCount(dayCount, start.month());
      let duration = getDurationInDays(dayCount);
      let isWeeklyFreq = freq.frquency_details && freq.frquency_details.freq_type && freq.frquency_details.week_days && freq.frquency_details.freq_type === "WEEKLY" ? true : false;
      let weekDays = isWeeklyFreq ? freq.frquency_details.week_days.split(",").sort() : [];
      let taskDuration = isWeeklyFreq ? freq.frquency_details.task_duration : "";

      return {
        start: moment(start).format("DD/MM/YYYY"),
        end: moment(end).format("DD/MM/YYYY"),
        start_date: freq.start_date,
        end_date: freq.end_date,
        dayDuration: dayCount,
        duration: duration,
        isWeeklyFreq: isWeeklyFreq,
        weekDays: weekDays,
        taskDuration: taskDuration,
        contract_id: job.contract_id ? job.contract_id : "no_contract",
        id: freq.quote_task_id,
        task_id: freq.task_id,
        quote_task_id: freq.quote_task_id,
        job_id: job.job_id,
        site_id: job.site_id,
        client_id: job.client_id,
        client_contact_person_id: job.client_contact_person_id,
        name: freq.quote_task_label,
        quote_type: job.quote_type ? job.quote_type : "QUOTE",
        selectable: true,
        isChild: true,
        isJob: false,
        task_status: freq.task_status ? freq.task_status : null,
        job_state: "Booked",
        dayStamp: moment(start).unix(),
        freq_status: freq.freq_status,
        main_task_label: freq.task_name
      };
    });
    return {
      ...job,
      _id: `job_${job.job_id}`,
      isJob: true,
      task_category: job.task_category,
      id: job.job_id,
      job_id: job.job_id,
      isChild: false,
      name: job.job_number,
      task_frequencies: allFreqs,
      job_task_type: allFreqs.length > 0 ? allFreqs[0].quote_type : null
    }
  }));
  let booked_tasks = [];
  let bookedIds = [];
  res.booked_tasks.forEach(task => {
    if (bookedIds.indexOf(task.task_id) === -1) {
      bookedIds.push(task.task_id);
      booked_tasks.push(task);
    }
  })
  allTasks.push(...booked_tasks.map(task => {
    let allFreqs = task.task_frequencies.map(freq => {
      let start = moment.utc(freq.start_date);
      let end = moment.utc(freq.end_date);
      let dayCount = moment(end).diff(start, "days") + 1;
      // let duration = getDurationFromCount(dayCount, start.month());
      let duration = getDurationInDays(dayCount);
      let isWeeklyFreq = freq.frquency_details && freq.frquency_details.freq_type && freq.frquency_details.week_days && freq.frquency_details.freq_type === "WEEKLY" ? true : false;
      let weekDays = isWeeklyFreq ? freq.frquency_details.week_days.split(",").sort() : [];
      let taskDuration = isWeeklyFreq ? freq.frquency_details.task_duration : "";
      return {
        ...freq,
        id: freq.quote_task_id,
        quote_task_id: freq.quote_task_id,
        start: moment(start).format("DD/MM/YYYY"),
        end: moment(end).format("DD/MM/YYYY"),
        start_date: freq.start_date,
        end_date: freq.end_date,
        dayDuration: dayCount,
        isWeeklyFreq: isWeeklyFreq,
        weekDays: weekDays,
        taskDuration: taskDuration,
        duration: duration,
        selectable: true,
        isChild: true,
        freq_status: freq.freq_status,
        site_id: task.site_id,
        contract_id: task.contract_id ? task.contract_id : "no_contract",
        job_id: null,
        client_id: task.client_id,
        client_contact_person_id: task.client_contact_person_id,
        site_id: task.site_id,
        name: freq.quote_task_label,
        main_task_label: task.task_name,
        quote_type: task.quote_type ? task.quote_type : "QUOTE",
        isJob: false,
        job_state: "Available Task",
        dayStamp: moment(start).unix(),
        task_status: null,
      }
    })
    return { ...task, _id: `task_${task.task_id}`, id: task.task_id, name: task.task_name, isJob: false, isChild: false, task_frequencies: allFreqs }
  }));

  return allTasks;
}

export const getTasks = (startDate, endDate, filters) => dispatch => {
  let url = CALENDAR_BOOKED_TASKS_URL;
  let filterString = serializeFilters(filters);
  url = url + filterString;
  return scopeApiInstance.get(url, {
    params: {
      start_date: moment(startDate).format("YYYY-MM-DD 00:00:00"),
      end_date: moment(endDate).format("YYYY-MM-DD 00:00:00"),
      page: 1,
      limit: 10000,
      ...(filters.site_id ? { site_id: filters.site_id } : {}),
      ...(filters.client_id ? { client_id: filters.client_id } : {}),
      ...(filters.contract_id ? { contract_id: filters.contract_id } : {}),
      ...(filters.state_id ? {state_id: filters.state_id} : {})
    }
  }).then(res => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(markTasks(res.data.data));
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getUnbookedTasks = (siteId, clientId) => dispatch => {
  let url = CALENDAR_UNBOOKED_TASKS_URL;
  return scopeApiInstance.get(url, {
    params: {
      site_id: siteId,
      ...(clientId ? { client_id: clientId } : {})
    }
  }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getTaskFrequencyCount = (formData) => dispatch => {
  let url = CALENDAR_FREQUENCY_COUNT_URL;
  return scopeApiInstance.put(url, formData).then(res => {
    let data = res.data.data;
    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}


export const addUpdateTaskFrequencies = (formData) => dispatch => {
  let url = CALENDAR_TASK_FREQUENCIES_URL;
  return scopeApiInstance.put(url, formData).then(res => {
    let data = res.data;
    if (data) {
      return Promise.resolve(data.message)
    }
    else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getJobTasks = (jobId) => dispatch => {
  let url = CALENDAR_JOB_TASKS_URL;
  return scopeApiInstance.get(url, {
    params: { job_id: jobId }
  }).then(res => {
    if (res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const addJobTaskReminders = (formData) => dispatch => {
  let url = CALENDAR_FREQUENCIES_REMINDER_URL;
  return scopeApiInstance.post(url, formData).then(res => {
    if (res.data) {
      return Promise.resolve(res.data.message)
    }
    else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const fetchBookedReminders = (jobId) => dispatch => {
  let url = CALENDAR_FREQUENCIES_REMINDER_URL;
  return scopeApiInstance.get(url, { params: { job_id: jobId } }).then(res => {
    if (res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getCalendarJobFrequencies = (jobId) => dispatch => {
  let url = CALENDAR_JOB_TASK_FREQUENCIES_URL;
  return scopeApiInstance.get(url, { params: { job_id: jobId } }).then(res => {
    if (res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getCalendarJobDetails = (jobId) => dispatch => {
  let url = CALENDAR_JOB_RESOURCING_URL;
  return scopeApiInstance.get(url, { params: { job_id: jobId } }).then(res => {
    if (res.data && res.data.data) {
      try {
        let jobs = serializeJobs(res.data.data, true);
        return Promise.resolve(jobs.length ? jobs[0] : {});
      } catch (e) {
        console.log(e)
      }
    } else {
      return Promise.reject()
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const setTaskResourcing = (formData) => dispatch => {
  let url = CALENDAR_TASK_RESOURCE_URL;
  return scopeApiInstance.post(url, formData).then(async (res) => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error)
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const getContractorsBySearch = (search = "", includeOrg = "0", page = 1) => dispatch => {
  let url = CALENDAR_SEARCH_CONTRACTORS_URL;
  if (search.length && search.length > 0) {
    url = `${url}?search=${search}&includeOrg=${includeOrg}&page=${page}`;
  } else {
    url = `${url}?page=${page}`
  }
  return baseApiInstance.get(url).then((res) => {
    let data = res.data.data;
    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject();
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const allocateJobManager = (formData) => dispatch => {
  let url = CALENDAR_ALLOCATE_JOB_MANAGER_URL;
  return scopeApiInstance.put(url, formData).then(async (res) => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error)
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const createUpdateCalendarJob = (formData) => dispatch => {
  const url = CALENDAR_CREATE_UPDATE_JOB_URL;
  return scopeApiInstance.put(url, formData)
    .then(res => {
      let data = res.data;
      if (data && data.message) {
        return Promise.resolve(data.message);
      } else {
        return Promise.reject();
      }
    })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}


export const createAdHocJob = (formData) => dispatch => {
  const url = CALENDAR_CREATE_AD_HOC_JOB_URL;
  return scopeApiInstance.put(url, formData)
    .then(res => {
      let data = res.data;
      if (data && data.message) {
        return Promise.resolve(data);
      } else {
        return Promise.reject();
      }
    })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const getShiftsMetadataResourcing = (jobId) => dispatch => {
  const url = CALENDAR_SHIFT_RESOURCING_URL;
  return scopeApiInstance.get(url, {
    params: {
      job_id: jobId
    }
  }).then(res => {
    if (res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const extendJob = (formData) => dispatch => {
  const url = CALENDAR_EXTEND_JOB_URL;
  return scopeApiInstance.put(url, formData)
    .then(res => {
      let data = res.data;
      if (data && data.message) {
        return Promise.resolve(data);
      } else {
        return Promise.reject();
      }
    })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const getJobsListView = (abortController = {}, params = {}) => () => {
  const url = CALENDAR_JOBS_URL;
  return scopeApiInstance.get(url, { params: { ...params }, ...abortController }).then(res => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getJobParentTasks = (abortController = {}, params = {}) => () => {
  const url = JOB_PARENT_TASKS_URL;
  return scopeApiInstance.get(url, { params: { ...params }, ...abortController }).then(res => {
    if (res && res.data && res.data.data) {
      let jobs = serializeResourcingTasks([res.data.data], true);
      return Promise.resolve(jobs.length ? jobs[0] : {});
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const setTaskAssignee = (formData) => dispatch => {
  let url = TASK_ASSIGNEE_URL;
  return scopeApiInstance.put(url, formData).then(async (res) => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error)
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const allocateAccManager = (formData) => dispatch => {
  let url = CALENDAR_ALLOCATE_ACC_MANAGER_URL;
  return scopeApiInstance.put(url, formData).then(async (res) => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error)
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const addEditJobShiftPlans = (formData, mode = "Add") => () => {
  const url = mode === "Edit" ? UPDATE_JOB_SHIFT_PLAN_URL : ADD_JOB_SHIFT_PLAN_URL;
  const method = mode === "Edit" ? scopeApiInstance.put : scopeApiInstance.post
  return method(url, formData).then(async (res) => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error)
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const getJobShiftPlanDetails = (planId, abortController = {}) => () => {
  return scopeApiInstance.get(`${GET_JOB_SHIFT_PLANNS_URL}/${planId}`, { ...abortController }).then(res => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const deleteShiftMetadata = (id) => () => {
  const url = CALENDAR_SHIFT_RESOURCING_URL;
  return scopeApiInstance.delete(url, { data: { id: id } }).then(res => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const deleteShiftPlan = (id) => () => {
  const url = DELETE_JOB_SHIFT_PLAN_URL;
  return scopeApiInstance.delete(url, { params: { id: id } }).then(res => {
    if (res.data.status) {
      return Promise.resolve(res.data.message && res.data.message);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const getAllSupervisors = (abortController = {}) => () => {
  return baseApiInstance.get(GET_ALL_SUPERVISORS_URL, { ...abortController }).then(res => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getScopeStates = (abortController = {}) => () => {
  return scopeApiInstance.get(GET_SCOPE_STATES_URL, { ...abortController }).then(res => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}
